/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 包含待检测文本 'keywords' 的JSON对象
 */
export type PostSensitiveWordAnalyzeRequest = { keywords: Array<string> };

export const PostSensitiveWordAnalyzeRequest$zodSchema: z.ZodType<
  PostSensitiveWordAnalyzeRequest
> = z.object({
  keywords: z.array(z.string()),
}).describe("包含待检测文本 'keywords' 的JSON对象");

/**
 * 请求频率超限
 */
export type PostSensitiveWordAnalyzeTooManyRequestsResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostSensitiveWordAnalyzeTooManyRequestsResponseBody$zodSchema:
  z.ZodType<PostSensitiveWordAnalyzeTooManyRequestsResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
  }).describe("请求频率超限");

/**
 * 未授权访问
 */
export type PostSensitiveWordAnalyzeUnauthorizedResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostSensitiveWordAnalyzeUnauthorizedResponseBody$zodSchema:
  z.ZodType<PostSensitiveWordAnalyzeUnauthorizedResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
  }).describe("未授权访问");

/**
 * 请求参数错误
 */
export type PostSensitiveWordAnalyzeBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostSensitiveWordAnalyzeBadRequestResponseBody$zodSchema:
  z.ZodType<PostSensitiveWordAnalyzeBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
  }).describe("请求参数错误");

export const PostSensitiveWordAnalyzeLabel = {
  Sensitive: "sensitive",
  Normal: "normal",
} as const;
export type PostSensitiveWordAnalyzeLabel = ClosedEnum<
  typeof PostSensitiveWordAnalyzeLabel
>;

export const PostSensitiveWordAnalyzeLabel$zodSchema = z.enum([
  "sensitive",
  "normal",
]);

export const PostSensitiveWordAnalyzeCategory = {
  Safe: "safe",
  Threat: "threat",
  Porn: "porn",
  Fraud: "fraud",
  Insult: "insult",
} as const;
export type PostSensitiveWordAnalyzeCategory = ClosedEnum<
  typeof PostSensitiveWordAnalyzeCategory
>;

export const PostSensitiveWordAnalyzeCategory$zodSchema = z.enum([
  "safe",
  "threat",
  "porn",
  "fraud",
  "insult",
]);

export type PostSensitiveWordAnalyzeResult = {
  k?: string | undefined;
  label?: PostSensitiveWordAnalyzeLabel | undefined;
  category?: PostSensitiveWordAnalyzeCategory | undefined;
  confidence?: number | undefined;
};

export const PostSensitiveWordAnalyzeResult$zodSchema: z.ZodType<
  PostSensitiveWordAnalyzeResult
> = z.object({
  category: PostSensitiveWordAnalyzeCategory$zodSchema.optional(),
  confidence: z.number().optional(),
  k: z.string().optional(),
  label: PostSensitiveWordAnalyzeLabel$zodSchema.optional(),
});

/**
 * 分析成功
 */
export type PostSensitiveWordAnalyzeResponseBody = {
  results?: Array<PostSensitiveWordAnalyzeResult> | undefined;
  total?: number | undefined;
};

export const PostSensitiveWordAnalyzeResponseBody$zodSchema: z.ZodType<
  PostSensitiveWordAnalyzeResponseBody
> = z.object({
  results: z.array(z.lazy(() => PostSensitiveWordAnalyzeResult$zodSchema))
    .optional(),
  total: z.int().optional(),
}).describe("分析成功");

export type PostSensitiveWordAnalyzeResponse =
  | PostSensitiveWordAnalyzeResponseBody
  | PostSensitiveWordAnalyzeBadRequestResponseBody
  | PostSensitiveWordAnalyzeUnauthorizedResponseBody
  | PostSensitiveWordAnalyzeTooManyRequestsResponseBody;

export const PostSensitiveWordAnalyzeResponse$zodSchema: z.ZodType<
  PostSensitiveWordAnalyzeResponse
> = z.union([
  z.lazy(() => PostSensitiveWordAnalyzeResponseBody$zodSchema),
  z.lazy(() => PostSensitiveWordAnalyzeBadRequestResponseBody$zodSchema),
  z.lazy(() => PostSensitiveWordAnalyzeUnauthorizedResponseBody$zodSchema),
  z.lazy(() => PostSensitiveWordAnalyzeTooManyRequestsResponseBody$zodSchema),
]);
